// @ts-nocheck
import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

function ConfirmDeleteDialog({ open, name, onConfirm, onClose }) {
    return (
        <Dialog open={ open } onClose={ onClose } maxWidth="xs" fullWidth aria-labelledby="confirm-delete-title">
            <DialogTitle id="confirm-delete-title" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box
                    component="span"
                    sx={{ display: 'inline-flex', p: 0.75, borderRadius: '50%', bgcolor: 'error.light', color: 'error.contrastText' }}
                >
                    <DeleteOutlineIcon fontSize="small" />
                </Box>
                Slet { name }?
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    { `Er du sikker på, at du vil slette ${name}? Det kan ikke fortrydes.` }
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={ onClose }>Fortryd</Button>
                <Button
                    variant="contained"
                    color="error"
                    autoFocus
                    onClick={ () => {
                        onConfirm();
                        onClose();
                    } }
                >
                    Slet
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConfirmDeleteDialog;
